import { Navigate, useLocation } from "react-router-dom";
import { maintenanceMode } from "../middleware/maintenance";

function MaintenanceRoute({ children }) {
  const location = useLocation();

  // Allow access to maintenance page itself
  if (maintenanceMode && location.pathname !== "/maintenance") {
    return <Navigate to="/maintenance" replace />;
  }

  // Prevent access to maintenance page when disabled
  if (!maintenanceMode && location.pathname === "/maintenance") {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default MaintenanceRoute;